<div id="openBookingsExtends" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" *ngIf="book != null">
        <h4 class="modal-title mt-0 w-100">Datos de reserva |
          <span class="bold" >{{book.code}}</span>
          <div class="float-right text-right">
            <button type="button" class="btn btn-secondary btn-sm hide-xs" data-dismiss="modal" (click)="close()">
              <i class="fas fa-arrow-left m-r-5"></i> Cerrar
            </button>
            <button type="button" class="btn btn-success btn-sm m-l-5" (click)="bookingAmortization(book)"
              *ngIf="book.total != book.total_paid" data-toggle="modal" data-target="#openExtendsBookingsAmortization">
              <i class="fas fa-money-bill-alt m-r-3"></i> Amortizar {{(book.total - book.total_paid).toFixed(2)}}
            </button> 
            <button class="btn btn-sm btn-primary m-l-5" *ngIf="book.is_checkout == false" (click)="edit(book.id)"><i
                class="fas fa-pen-alt m-r-2"></i>Editar
            </button>
          </div>
        </h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <div class="modal-body p-t-0" *ngIf="book != null">
        <div class="card-body faq-box boder-left-{{book.status_booking.class}}">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Estado</div>
                  <div class="child-right">
                    <span
                      class="badge f-s-12 badge-{{book.status_booking.class}}">{{book.status_booking.message}}</span>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Código reserva</div>
                  <div class="child-right">
                    <span class="bold">{{book.code}}
                      <i *ngIf="book.is_favorite" class="fas fa-star m-l-2 color-favorite"></i>
                    </span>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left bold">Responsable</div>
                  <div class="child-right">
                    {{book.client_data.fullname}}
                    <p class="bold f-s-10 m-b-0">{{book.client_data.typeDocument}} :
                      {{book.client_data.document}}</p>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">N° PAX</div>
                  <div class="child-right">
                    {{book.nro_pax}} (personas)
                    <div class="d-inline-block m-l-5" *ngIf="book.is_reference_pax">
                      REF:
                      <span>Niños ({{book.nro_pax_childs}})</span>,
                      <span>Adultos({{book.nro_pax_adults}})</span>,
                      <span>Ancianos ({{book.nro_pax_olds}})</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Teléfonos</div>
                  <div class="child-right">
                    {{book.client_data.cellphone}}
                    <span class="m-l-5" ng-if="book.client_data.telephone != null">
                      - {{book.client_data.telephone}}
                    </span>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Fecha de llegada</div>
                  <div class="child-right">
                    {{book.date_arrival | date: 'mediumDate'}}
                    <span class="bold f-s-10 m-b-0 m-l-3">Hora : {{book.time_arrival}}</span>
                    <ng-container *ngIf="book.date_departure != null">
                      <span class="m-l-10 f-s-11">- Salida ({{book.date_departure | date: 'mediumDate'}})</span>
                    </ng-container>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Referencia llegada</div>
                  <div class="child-right">
                    {{book.arrivalplace_data.description}}
                    <span class="m-l-5">(<span>{{book.arrival_place}}</span>)</span>
                  </div>
                </div>
                <ng-container *ngIf="book.employee_id != null">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Asesor(a)</div>
                    <div class="child-right">
                      {{book.employee_data.fullname}}
                      <p class="bold f-s-10 m-b-0">DOC:{{book.employee_data.document}}</p>
                    </div>
                  </div>
                </ng-container>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">N° ref. ó etiqueta 
                    <span *ngIf="book.workinggroup_id != null">/ Grupo</span>
                  </div>
                  <div class="child-right">
                    {{book.reference_voucher}}
                    <ng-container *ngIf="book.workinggroup_id != null">
                      / <span class="badge badge-dark m-l-5 f-s-9">{{book.workinggroup_data.description}}</span>
                    </ng-container>                  
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row" *ngIf="book.is_book_hotel">
                  <div class="child-left"><i class="fas fa-hotel"></i></div>
                  <div class="child-right">
                    <span class="badge badge-hotel">RESERVA SOLO HOTEL</span>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">R.Usuario</div>
                  <div class="child-right">
                    <span class="text-uppercase">{{book.user_data.username}} </span>  
                    <ng-container *ngIf="book.user_updated_id != null">
                      <span class="m-l-10 f-s-10">(última actualización usuario: {{book.user_updated_data.username}} )</span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-map-marker-alt m-r-5"></i>Datos de tours
            </p>
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>Nombre tours</th>
                    <th class="text-center">N° PAX</th>
                    <th>Vehículo</th>
                    <th>Turno</th>
                    <th>F. asignada</th>
                    <th>Estado</th>
                    <th>F. realizada</th>
                    <th>Obs.</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="tours.length == 0">
                    <tr>
                      <td colspan="6"><span>No se encontraron registros</span></td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="tours.length > 0">
                    <tr *ngFor="let item of tours; let index_ = index" [ngClass]="{'text-open': item.is_open}">
                      <td>
                        {{item.description}}
                        <span *ngIf="item.is_open" class="m-l-5">(Estado abierto)</span>
                        <p class="f-s-10" *ngIf="item.is_transfer == true">
                          <span class="bold">TRASPASADO: ({{item.agency_operator.tradename}}) </span>
                        </p>
                      </td>
                      <td class="text-center">{{item.quantity}}</td>

                      <td>
                        <span
                          class="badge f-s-10 badge-{{item.vehicle_tour_content.class}}">{{item.vehicle_tour_content.description}}</span>
                      </td>
                      <td><span class="bold">{{item.shift_tour_content.description}}</span></td>
                      <td>{{item.date_assigned | date: 'mediumDate'}}
                      <td *ngIf="item.group_assigned != null">
                        <span class="badge badge-pink">Asignado</span>
                        <p ng-click="groupDetail(item.group_assigned.group_id)"
                          class="bold pointer grid__link d-inline f-s-10">
                          {{item.group_assigned.group_code}}</p>
                      </td>
                      <td *ngIf="item.group_assigned == null">
                        <span class="badge badge-success f-s-10" *ngIf="item.status_realized == true">Confirmado</span>
                        <span class="badge badge-warning f-s-10" *ngIf="item.status_realized == false">Pendiente</span>
                      </td>
                      <td>
                        <span *ngIf="item.is_transfer == false">
                          {{item.date_realized | date: 'mediumDate'}}
                        </span>
                      </td>
                      <td class="text-center">{{item.observation}}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="m-t-10">
              <label class="f-s-11">Ubicación y referencias de ubicación
                <i class="fas fa-info-circle m-l-5" data-toggle="tooltip" data-placement="right"
                  data-original-title="Información de hotel, dirección, para el recojo de los tours del pasajero."></i></label>
              <span *ngIf="book.reference_location == null">Sin especificar</span>
              <textarea *ngIf="book.reference_location != null" disabled rows="2"
                class="form-control form-control-sm no-resize f-s-11 select-read"
                ng-model="book.reference_location"></textarea>
            </div>
          </div>
          <div class="col-12 m-t-15">
            <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-bed m-r-5"></i>Datos reservas de alojamiento
            </p>
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>Código</th>
                    <th>Nombre Hotel</th>
                    <th>Detalle Hab.</th>
                    <th>Deuda</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="hotels.length == 0">
                    <tr>
                      <td colspan="6">No se registran datos</td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="hotels.length > 0">
                    <tr *ngFor="let item of hotels; let index_ = index">
                      <td><span class="bold text-primary">{{item.code}}</span></td>
                      <td>
                        <span class="bold">{{item.tradename}}</span> ({{item.citietouristic}})
                        <p class="m-b-0 f-s-10">Cel: {{item.cellphone}}</p>
                      </td>
                      <td>
                        <span *ngFor="let data of item.detail_bedrooms">
                          <span>{{data.typebedroom}}
                            <span class="f-s-11">({{data.quantity}} hab. x {{data.nights}}
                              noches)</span> ,</span>
                        </span>
                      </td>
                      <td>
                        <span class="text-danger">{{item.total | currency:'S/'}}</span>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 m-t-15 hide" style="display: none;">
            <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-plane-departure m-r-5"></i>Datos de
              vuelo</p>
            <div class="m-t-10">
              <span ng-if="book.register_flight == null">Sin especificar</span>
              <textarea ng-if="book.register_flight != null" ng-disabled="true" rows="2"
                class="form-control form-control-sm no-resize f-s-11 select-read"
                ng-model="book.register_flight"></textarea>
            </div>
          </div>
          <div class="col-12 m-t-20">
            <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-info-circle m-r-5"></i>RESUMEN TOTAL
              S/</p>
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>TOTAL TOURS</th>
                    <th>TOTAL HOTEL</th>
                    <th>TOTAL VUELO</th>
                    <th class="text-right">
                      <span class="text-primary">TOTAL PAGAR</span>
                    </th>
                    <th class="text-right">
                      <span class="text-success">PAGADO</span>
                    </th>
                    <th class="text-right">
                      <span class="text-danger">SALDO PENDIENTE</span>
                    </th>
                    <th class="text-right">
                      <span class="text-info">FACTURADO</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{toolsService.momeySol()}}{{book.subtotal_tour}}</td>
                    <td>{{toolsService.momeySol()}}{{book.subtotal_hotel}}</td>
                    <td>{{toolsService.momeySol()}}{{book.subtotal_flight}}</td>
                    <td class="text-right">
                      <span class="text-primary bold">{{toolsService.momeySol()}}{{book.total}}</span>
                    </td>
                    <td class="text-right">
                      <span class="text-success bold">{{toolsService.momeySol()}}{{book.total_paid}}</span>
                    </td>
                    <td class="text-right">
                      <span class="text-danger bold">{{toolsService.momeySol()}}{{book.total - book.total_paid}}</span>
                    </td>
                    <td class="text-right">
                      <span class="text-info bold">{{toolsService.momeySol()}}{{book.total_billing}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 m-t-20">
            <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-money-bill-alt m-r-5"></i>Comprobantes y
              cobros realizados</p>
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>R.Usuario</th>
                    <th>Tipo comprobante</th>
                    <th>N° comprobante</th>
                    <th>Fecha</th>
                    <th class="w-15 text-center">Método pago</th>
                    <th class="w-15 text-right">Pagado</th>
                    <th class="w-15 text-center">Comprobante</th>
                    <th class="w-15 text-center">constancia</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="movements.length == 0">
                    <tr>
                      <td colspan="7">No registra datos de cobros.</td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="movements.length > 0">
                    <tr *ngFor="let item of movements; let index_ = index">
                      <td>{{item.user_data.username}}</td>
                      <td>{{item.typevoucher}}</td>
                      <td>{{item.nro_voucher}}</td>
                      <td>{{item.date_movement  |  date: 'YYYY-MM-dd'}}</td>
                      <td class="w-15 text-center">{{item.paymethod}}</td>
                      <td class="w-15 text-right">{{toolsService.momeySol()}}{{item.total_amount}}</td>
                      <td class="w-15 text-center">
                        <div *ngIf="item.date_repayment == null">
                          <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                            href="/{{branchofficeSlug}}/api/print/billing/document/{{item.id}}"
                            *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                            <i class="fas fa-print f-s-16"></i>
                          </a>
                          <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                            href="/{{branchofficeSlug}}/api/print/income/document/{{item.id}}"
                            *ngIf="item.voucher_id == typevoucher_income.id || item.voucher_id == typevoucher_expense.id">
                            <i class="fas fa-print f-s-16"></i>
                          </a>
                        </div>
                        <div *ngIf="item.date_repayment != null">
                          <span class="badge badge-danger f-s-11">Anulado</span>
                        </div>
                      </td>
                      <td class="text-center">
                        <span *ngIf="item.url_image != null">
                          <a class="text-info pointer bold" href="tenants/{{item.url_image}}" download>
                            <i class="fas fa-file-download f-s-16"></i>
                          </a>
                        </span>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 m-t-20">
            <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-users m-r-5"></i>Comisiones</p>
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>Nombre mototaxista</th>
                    <th>Empresa</th>
                    <th>Celular</th>
                    <th>Fecha</th>
                    <th class="text-center">COMISIÓN HOTEL</th>
                    <th class="text-center">COMISIÓN TOURS</th>
                    <th class="text-center">TOTAL COMISIÓN</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="commissions.length == 0">
                    <tr>
                      <td colspan="7">No registra datos de cobros.</td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="commissions.length > 0">
                    <tr *ngFor="let item of commissions; let index_ = index">
                      <td>
                        {{item.collaborator_data.fullname}}
                        <p class="bold f-s-10 m-b-0">Doc : {{item.collaborator_data.document}}</p>
                      </td>
                      <td>{{item.collaborator_data.partnercompany}}</td>
                      <td>{{item.collaborator_data.cellphone}}</td>
                      <td>{{item.date_commision}}</td>
                      <td class="text-center">
                        <ng-container *ngIf="item.total_hotel != null">
                          {{toolsService.momeySol()}}{{item.total_hotel}}
                        </ng-container>
                      </td>
                      <td class="text-center">
                        <ng-container *ngIf="item.total_hotel != null">
                          {{toolsService.momeySol()}}{{item.total_tour}}
                        </ng-container>
                      </td>
                      <td class="text-center">{{toolsService.momeySol()}}{{item.total_commission}}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal" (click)="close()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
<app-bookings-amortization-extends (onSubmitEvent)="beforeAmortization($event)"></app-bookings-amortization-extends>
<app-bookings-commission-extends (onSubmitEvent)="beforeAmortization($event)"></app-bookings-commission-extends>
<!-- <app-transfers-extends (onSubmitEvent)="afterTransfer($event)"></app-transfers-extends> -->
